<template>
  <transition name="default-opacity-transition" mode="out-in">
    <router-view
      v-if="!loading"
      :key="assetModule && assetModule.id"
      :asset="currentAsset"
      :asset-type="currentAssetType"
      :asset-module="assetModule"
    />
    <s-loader v-else/>
  </transition>
</template>

<script>
import ModuleMenuService from '@/domain/services/installation/modules/menu';
import loadingMixin from '@/services/loadingMixin';
import AssetAccessorMixin from '@/domain/mixins/installation/assetAccessorMixin';
import eventBus from '@/services/globalEventBus';
import menuEvents from '@/domain/events/menu';
import { mapGetters } from 'vuex';

export default {
  name: 'Asset',
  mixins: [
    loadingMixin,
    AssetAccessorMixin,
  ],
  data: () => ({
    assetModule: null,
  }),
  computed: {
    ...mapGetters([
      'assetSubMenu',
    ]),
  },
  created() {
    this.initListener();
    this.handleMenuItems(this.assetSubMenu.items);
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    initListener() {
      eventBus.on(menuEvents.refreshMenuItems, this.handleMenuItems, this);
    },
    removeListener() {
      eventBus.off(menuEvents.refreshMenuItems, this.handleMenuItems, this);
    },
    async handleMenuItems(menuItems) {
      if (!menuItems) {
        return;
      }
      this.startLoading();
      const modulesList = ModuleMenuService.mapEngineeringModuleAndSensorList(menuItems);
      await ModuleMenuService.verifyModuleRoute(this.$route, modulesList);
      this.endLoading();
    },
  },
};
</script>

<style lang="sass" scoped>
.supervision
  &__breadcrumb-custom
    text-align: right

::v-deep
  div.app-content__main-content
    background: var(--color-background-light)
</style>
